import React from "react";
import { CloseButton, Group, Paper, Portal, Text, ThemeIcon } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectShouldShowSystemOverlayWarning } from "@store/connection/connectionSelectors";
import { dismissSystemOverlayWarning } from "@store/connection/connectionSlice";

const SystemOverlayWarningBanner: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showWarning = useSelector(selectShouldShowSystemOverlayWarning);

  if (!showWarning) {
    return null;
  }

  return (
    <Portal>
      <Paper
        p="md"
        radius="md"
        withBorder
        shadow="md"
        style={{
          position: "fixed",
          bottom: 16,
          left: 16,
          zIndex: 10001,
          width: "min(420px, calc(100vw - 32px))",
          backgroundColor: "var(--oculera-tint-orange)",
          borderColor: "var(--oculera-tint-orange-border)",
        }}
      >
        <Group gap="sm" wrap="nowrap" align="flex-start">
          <ThemeIcon size={28} radius="xl" variant="light" color="orange">
            <IconAlertTriangle size={18} />
          </ThemeIcon>
          <div style={{ flex: 1 }}>
            <Text size="sm" fw={600} c="orange.9">
              {t("SystemOverlay.warningTitle")}
            </Text>
            <Text size="sm" c="orange.9">
              {t("SystemOverlay.warningMessage")}
            </Text>
          </div>
          <CloseButton
            aria-label={t("SystemOverlay.dismissWarning")}
            c="orange.9"
            onClick={() => dispatch(dismissSystemOverlayWarning())}
          />
        </Group>
      </Paper>
    </Portal>
  );
};

export default SystemOverlayWarningBanner;
